import { useCallback, useState } from 'react';

import AddchartOutlined from '@mui/icons-material/AddchartOutlined';

import { useDashboardEditLockContext } from '@/features/Dashboard/context/DashboardEditLockContext';
import useUserDetails from '@/hooks/useUserDetails';
import WidgetButton from '@/shared/ui/primitives/WidgetButton';
import type { BaseTabType } from '@/types/markets';

import AddToDashboardMenu from './AddToDashboardMenu';

const AddToDashboardButton = ({ tab }: { tab: BaseTabType }) => {
  const { isUserExpired } = useUserDetails();
  const { requestExclusiveAction } = useDashboardEditLockContext();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const menuOpen = Boolean(anchorEl);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      const target = event.currentTarget;
      requestExclusiveAction(() => {
        setAnchorEl(prev => (prev ? null : target));
      });
    },
    [requestExclusiveAction]
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <WidgetButton
        disabled={isUserExpired}
        icon={<AddchartOutlined sx={{ fontSize: '14px' }} />}
        title='Add widget to dashboard'
        onClick={handleClick}
      />

      <AddToDashboardMenu
        anchorEl={anchorEl}
        open={menuOpen}
        tab={tab}
        onClose={handleClose}
      />
    </>
  );
};

export default AddToDashboardButton;
